import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=6b0feb92&scoped=true"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"
import style0 from "./Publication.vue?vue&type=style&index=0&id=6b0feb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0feb92",
  null
  
)

export default component.exports